import { extendTheme } from "@chakra-ui/react"
const theme = extendTheme({
  fonts: {
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
})

export default theme
